export default __webpack_public_path__ + "static/speaker8-824f52ce62c6913d9c3e6383a7e455fa.jpg";